import React from 'react';

import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';

import { FolderList } from '../components/folders/FolderList';
import { ProductList } from '../components/product/ProductList';
import { DownloadActions } from '../components/downloads/DownloadActions';

import { useProductStore } from '../stores/productStore';
import { useFolderStore } from '../stores/folderStore';
import type { BulkUpdates } from '../types/bulk';

export default function Home() {

    const {
        products,
        updateProduct,
        deleteProduct,
        updateMultipleProducts,
    } = useProductStore();

    const { currentFolderId } = useFolderStore();

    const filteredProducts = products.filter(product => {
        return currentFolderId === null || product.folderId === currentFolderId;
    });

    const handleBulkUpdate = (updates: BulkUpdates, selectedIds: number[]) => {
        updateMultipleProducts(updates, selectedIds);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Header />
                <main className="py-4 sm:py-8">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <DownloadActions />
                        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                            <div className="lg:col-span-1">
                                <FolderList />
                            </div>
                            <div className="lg:col-span-3">
                                <ProductList
                                    products={filteredProducts}
                                    onUpdate={updateProduct}
                                    onDelete={deleteProduct}
                                    onBulkUpdate={handleBulkUpdate}
                                />
                            </div>
                        </div>
                    </div>
                </main>
            <Footer />
         </div>
    )}